<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/demo/proparts/list";
import editDialog from "@/components/demo/proparts/editDialog";

export default {
  name: "proparts",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {
    delRows() {
      // let rows = this.$refs.list.getCheckedRows();
      // if (rows.length == 0) {
      //   this.$message.warning("请选择要删除的数据");
      //   return;
      // }
      // this.$confirm("确认删除所选的数据吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     let ids = rows.map((item) => {
      //       return item.propartsId;
      //     });
      //     this.$refs.list.delRange(ids);
      //   })
      //   .catch(() => { });
    },
  },
};
</script>